import React from 'react';
import FundingCopyableField from './FundingCopyableField';

const CopyableValue = ({
  value,
  displayValue,
  className = '',
  stopPropagation = true,
  monospace = false,
  testId,
}) => (
  <FundingCopyableField
    inline
    value={value}
    displayValue={displayValue}
    className={className}
    stopPropagation={stopPropagation}
    monospace={monospace}
    testId={testId}
  />
);

export default CopyableValue;
